import type { DocMigration } from "../docMigration";

const baseEntityRefV1Fields = ["id", "docRefId", "entityType"] as const;
const baseEntityRefV2Fields = ["includedBy", "entityRefType"] as const;
const baseEntityRefFields = [...baseEntityRefV1Fields, ...baseEntityRefV2Fields] as const;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_466: DocMigration = {
  maxSchemaVersion: "0.0.466",
  description: "Remove entity ref overrides for option sets",
  apply(json: any): any {
    if (!Object.keys(json.entityRefs ?? {}).length) {
      return json;
    }

    for (const id in json.optionSets) {
      if (!json.entityRefs[id]) {
        continue;
      }

      Object.keys(json.entityRefs[id]).forEach((key) => {
        if (!baseEntityRefFields.includes(key as any)) {
          delete json.entityRefs[id][key];
        }
      });
    }

    return json;
  },
};

export default migration_0_0_466;
